<script>
    export let progress = 0;
    export let scale = 7; // horse size = png size / scale
    export let calculatedProgress = false;
    export let showHorse = false;
    export let showPercentage = false;
</script>
  
<style>
  #horse {
    position: relative;
    transform: translateX(-50%); /* align horse with middle of progress bar*/
    z-index: 10;
    animation-duration: 0.3s;
  }
</style>
  
<div>
  {#if calculatedProgress}
    {#if showHorse}
      <div id="horse" style="left: {progress}%; background-image: url('/assets/horse_{(Math.floor(progress)*2) % 11}.png'); width: calc(720px / {scale}); height: calc(360px / {scale}); background-size: cover;"/>
    {/if}
    <div class="w-full bg-secondary rounded-full h-2.5">
      <div class="bg-accent2 h-2.5 rounded-full" style="width: {progress}%"></div>
    </div>
    {#if showPercentage}
      <div class="text-center w-[100%]">{Math.floor(progress)}%</div>
    {/if}
  {/if}
</div>
